import React from 'react';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { SetupTab } from 'areas/shared/pages/setup';
import { TextAreaBox, Switch, DatePicker } from 'fw/forms';
import { Label, ActionButton, Button } from 'fw/components';
import * as API from 'modules/app/API';
import * as App from 'modules/app/App';
import { CommentsGrid } from 'areas/shared/components';
import ReviewPanel from 'areas/admin/certification/shared/ReviewPanel';
import AppReviewToolbar from 'areas/admin/certification/shared/AppReviewToolbar';
import AdminStepToolbar from 'areas/admin/certification/shared/AdminStepToolbar';
import * as ReportManager from 'modules/reports/ReportManager';

class CompanyHistory extends SetupTab {
    initialForm() {
        return {
            entityId: "",
            certificationId: "",
            certificationKey: "",
            businessStartedDate: "",
            businessStartedAdditionalInfo: "",
            becomeMajorityOwnerDate: "",
            becomeMajorityOwnerAdditionalInfo: "",
            existAdditionalOwners: false,
            additionalOwnersExplanation: "",
            rowVersion: null,
            comments: null,
            hasBusinessStartedAdditionalInfo: false,
            hasBecomeMajorityOwnerAdditionalInfo: false,
            reviewComment: ''
        }
    }

    privileges() {
        return {
            add: App.hasPrivilege('AdminSiteReviewAccess'),
            edit: App.hasPrivilege('AdminSiteReviewAccess')
        }
    }

    urls() {
        return {
            get: API.Admin.url('/siteReview/getBusinessHistory'),
            save: API.Admin.url('/siteReview/saveBusinessHistory')
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId,
        }
    }

    saveRequest() {
        let strAddInfo = this.state.form.businessStartedAdditionalInfo;
        let majAddInfo = this.state.form.becomeMajorityOwnerAdditionalInfo;
        this.state.form.hasBusinessStartedAdditionalInfo = strAddInfo && (strAddInfo.trim() !== "");
        this.state.form.hasBecomeMajorityOwnerAdditionalInfo = majAddInfo && (majAddInfo.trim() !== "");

        return {
            entityId: this.state.form.entityId,
            certificationId: this.state.form.certificationId,
            certificationKey: this.props.selectedId,
            businessStartedDate: this.state.form.businessStartedDate,
            businessStartedAdditionalInfo: this.state.form.hasBusinessStartedAdditionalInfo ? this.state.form.businessStartedAdditionalInfo : null,
            becomeMajorityOwnerDate: this.state.form.becomeMajorityOwnerDate,
            becomeMajorityOwnerAdditionalInfo: this.state.form.hasBecomeMajorityOwnerAdditionalInfo ? this.state.form.becomeMajorityOwnerAdditionalInfo : null,
            existAdditionalOwners: +this.state.form.existAdditionalOwners,
            additionalOwnersExplanation: this.state.form.additionalOwnersExplanation,
            rowVersion: this.state.form.rowVersion,
            reviewStatus: this.state.form.reviewStatus,
            reviewComment: this.state.reviewComment
        }
    }

    isEnabled(data) {
        return !data.isReviewFinished;
    }

    isValidated(data) {
        return data.isSubmitted;
    }

    updatePostData = (form, dirty) => {
        this.setState({ form })

        if (dirty === true) this.dirt()
    }

    beforeSave = (cb) => {
        this._ast.checkReviewStatus(cb);
    }

    ready = () => {
        // If slected form is paper -> Redirect to FinalRecomm
        if (this.state.form.isPaperForm)
            window.location.href = `/admin/siteReview/${this.props.selectedId}/finalRecomm/${this.props.queueTypeCode}`;
    }

    handleReviewStatus = (formReview) => {
        let form = this.state.form;
        form["reviewStatus"] = formReview.isReviewCompleted;

        this.updatePostData(form, true);
    };

    handleStepCommentSave = (formParam, callback) => {
        let form = this.state.form;

        if (formParam && formParam.comments)
            form.comments = formParam.comments;

        this.updatePostData(form, false);

        if (callback)
            callback();
        else
            this.handleSubmit();
    }

    handleAdminStepToolbar = () => {
        this.handleSubmit();
    }

    handleAppReviewToolbar = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentsGrid = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentChange = (comment) => {
        this.dirt();
        this.setState({
            reviewComment: comment
        });
    }

    handleUpdateComments(comments) {
        let form = {
            ...this.state.form,
            comments
        };
        this.updatePostData(form, false);
    }

    addBusinessStartedAdditionalInfo = () => {
        let form = this.state.form;
        form["hasBusinessStartedAdditionalInfo"] = true;
        this.updatePostData(form, true);
    };

    addBecomeMajorityOwnerAdditionalInfo = () => {
        let form = this.state.form;
        form["hasBecomeMajorityOwnerAdditionalInfo"] = true;
        this.updatePostData(form, true);
    };

    blankAdditionalOwnersExplanation = () => {
        let form = this.state.form;

        if (!form.additionalOwners)
            form.additionalOwnersExplanation = null;

        this.updatePostData(form, true);
    }

    handlePrint = () => {
        const rq = Object.assign({
            reportType: "SiteReviewBusinessHistoryReport",
            format: "PDF",
            parameters: {
                CertificationId: this.state.form.certificationId
            }
        });

        ReportManager.execute(rq);
    };

    afterSave = (entityId, data) => {
        this.addCommentFromSave(data.reviewComment);
    }

    addCommentFromSave = (comment) =>{
        if (comment === null) 
            return;
           
        let comments = this.state.form.comments;
                
        comments.unshift({
            commentId: comment.commentId,
            reviewTypeDescription: comment.reviewTypeDescription,
            queueTypeDescription: comment.queueTypeDescription,
            content: comment.content,
            addedDate: comment.addedAt,
            addedBy: comment.addedBy,
            commentTypeCode: comment.commentTypeCode
        });

        let form = {
            ...this.state.form,
            comments
        };

        this.updatePostData(form, false);

        // Clean Add Comment textbox
        this._commentsGrid.cleanComment();
        this.setState({ reviewComment: '' });

    }

    renderAdminStepToolbar = () => {
        const disableCancel = !this.state.buttons.cancel;
        //Show cancel
        const showCancel = this.state.showButtons.cancel;
        //Show save 
        const showSave = this.state.showButtons.save && this.state.enabled;
        
        return (
            <AdminStepToolbar
                ref={(c) => { this._ast = c }}
                onCommentSave={this.handleStepCommentSave}
                onSave={this.handleAdminStepToolbar}
                certificationKey={this.props.selectedId}
                reviewTypeCode={'SCH'}
                queueTypeCode={'STR'}
                reviewStatus={this.state.form.reviewStatus}
                comments={this.state.form.comments}
                showCancel={(showCancel && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                showSave={(showSave && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                onCancel={this.handleCancel}
                disableCancel={disableCancel}
                setupProps={this.props.setupProps}
                handleTabSelect={this.props.handleTabSelect}
            />)
    }

    renderButtons = () => {
        return (
            <React.Fragment>
                <hr />
                <Row>
                    <Col md={6}>
                    </Col>
                    <Col md={2}>
                        {this.state.form.showReview ?
                            <AppReviewToolbar
                                queueTypeCode={'STR'}
                                reviewTypeCode={'SCH'}
                                comments={this.state.form.comments}
                                onFlagSave={this.handleAppReviewToolbar}
                                certificationKey={this.props.selectedId} />
                            : null}
                    </Col>
                    <Col md={4}>
                        {this.renderAdminStepToolbar()}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <h3>
                                    {this.state.form.siteReviewTitle}
                                    {this.renderAdminStepToolbar()}
                                    <div className="pull-right"><ActionButton id="btnPrint" onClick={this.handlePrint} icon="print" bsSize="sm">Print</ActionButton></div>
                                </h3>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={5}>
                                <FormGroup>
                                    <Label htmlFor='businessStartedDate' required>
                                        When was the Company Created?
                                    </Label>
                                    <DatePicker
                                        required
                                        name="businessStartedDate"
                                        placeholder="Select Date"
                                        showTime={false}
                                        className='dpThin'
                                    />
                                    <br />
                                    {!this.state.form.isReviewFinished &&
										<Button type="button" bsStyle="link" onClick={this.addBusinessStartedAdditionalInfo}>
											Add Additional Information
										</Button>
									}
                                </FormGroup>
                            </Col>
                            <Col md={2}></Col>
                            <Col md={5}>
                                {this.state.form.hasBusinessStartedAdditionalInfo || this.state.form.businessStartedAdditionalInfo ?
                                    (
                                        <FormGroup>
                                            <TextAreaBox name="businessStartedAdditionalInfo" maxLength={500} placeholder="Please enter your additional Information here..." rows={4} />
                                        </FormGroup>
                                    ) : null}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={5}>
                                <FormGroup>
                                    <Label htmlFor='becomeMajorityOwnerDate' required>
                                        When did you become the Majority Owner?
                                    </Label>
                                    <DatePicker
                                        required
                                        name="becomeMajorityOwnerDate"
                                        placeholder="Select Date"
                                        showTime={false}
                                        className='dpThin'
                                    />
                                    <br />
                                    {!this.state.form.isReviewFinished && 
										<Button type="button" bsStyle="link" onClick={this.addBecomeMajorityOwnerAdditionalInfo}>
											Add Additional Information
										</Button>
									}
                                </FormGroup>
                            </Col>
                            <Col md={2}></Col>
                            <Col md={5}>
                                {this.state.form.hasBecomeMajorityOwnerAdditionalInfo || this.state.form.becomeMajorityOwnerAdditionalInfo ?
                                    (
                                        <FormGroup>
                                            <TextAreaBox name="becomeMajorityOwnerAdditionalInfo" maxLength={500} placeholder="Please enter your additional Information here..." rows={4} />
                                        </FormGroup>
                                    ) : null}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={5}>
                                <FormGroup>
                                    <Label htmlFor='existAdditionalOwners'>Are there additional Owners of your Company that were not mentioned before?</Label>
                                    <Switch onChange={this.blankAdditionalOwnersExplanation} name="existAdditionalOwners" labelLeft="No" labelRight="Yes" bsStyle="success" />
                                </FormGroup>
                                {this.state.form.existAdditionalOwners ?
                                    (
                                        <FormGroup>
                                            <Label required>Please explain the additional Owners of the Company</Label>
                                            <TextAreaBox
                                                required
                                                name="additionalOwnersExplanation"
                                                placeholder="Please explain the additional Owners of the Company"
                                                maxLength={500}
                                                rows={3} />
                                        </FormGroup>
                                    ) : null}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <hr />
                            </Col>
                        </Row>
                        
                    </Col>
                </Row>
                <Row>
                    <CommentsGrid
                        ref={(c) => { this._commentsGrid = c }}
                        comments={this.state.form.comments}
                        documents={this.state.form.reviewDocuments}
                        certificationKey={this.props.selectedId}
                        reviewTypeCode={"SCH"}
                        queueTypeCode={"STR"}
                        enableExport={true}
                        entityId={this.state.form.entityId}
                        readonly={!this.state.privileges.edit || !this.state.enabled}
                        onSave={this.handleCommentsGrid}
                        onCommentChange={this.handleCommentChange} />
                </Row>
                {this.state.form.showComplete ?
                    <Row>
                        <ReviewPanel stepName="Company History" onChange={this.handleReviewStatus} reviewStatus={this.state.form.reviewStatus} />
                    </Row>
                : null}
            </React.Fragment>
        )
    }
}

export default CompanyHistory;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/siteReview/siteReviewInfo/companyHistory/CompanyHistory.js